import React from 'react'

import { logger } from '@app/common/logger/logger'
import { openDocuments } from '@app/modules/Auth/documentLink'
import { Document } from '@app/queries/CustomerAsLawyer/models'

type Props = { documents?: Document[] }

export const OpenAllDocuments = ({ documents }: Props) => {
  const openEachDocumentInNewTab = (e) => {
    e.preventDefault()

    openDocuments((documents || []).map((messageDocument) => messageDocument.fileUrl)).catch(
      (error) => {
        logger.error(`unable to openEachDocumentInNewTab on OpenAllDocuments with ${error.message}`)
      }
    )
  }

  return (
    <a href={'#'} onClick={openEachDocumentInNewTab}>
      Alle Dokumente öffnen
    </a>
  )
}
